// src/stores/caseStore.js
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { CasesService, type CustomerCase as Case, type DataMapper } from '@/types/generated'
import router from '@/router'

// Define the store function
export const useCaseStore = defineStore('caseStore', () => {
  // State
  const caseRecord = ref<Case | null>(null)
  const mappers = ref<DataMapper[]>([])
  const lawSpecificMappers = computed(() =>
    mappers.value.filter((mapper) => mapper.is_law_specific_field)
  )

  // Actions (asynchronous actions such as fetching data)
  async function fetchCase(uuid: string) {
    caseRecord.value = await CasesService.casesRetrieve({ uuid: uuid })
  }

  async function fetchMappers(uuid: string) {
    mappers.value = (
      await CasesService.casesDatamappersList({
        uuid: uuid
      })
    ).results as DataMapper[]
  }

  async function loadCase(uuid: string) {
    await Promise.all([fetchCase(uuid), fetchMappers(uuid)])
  }

  // Return state, getters and actions
  return {
    caseRecord,
    mappers,
    lawSpecificMappers,
    loadCase
  }
})
